export enum EPostState {
  draft = 'draft',
  scheduled = 'scheduled',
  published = 'published',
  failed = 'failed',
  paused = 'paused',
}
